import React, { useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

interface SLAPerformanceChartProps {
  slaData: any;
}

export const SLAPerformanceChart: React.FC<SLAPerformanceChartProps> = ({
  slaData,
}) => {
  const [timePeriod, setTimePeriod] = useState("30");

  const monthlyData = slaData?.result?.monthlyData?.map((item) => ({
    month: item.month,
    within: item.withinSlaCount,
    breached: item.breachedSlaCount,
    rate: item.withinSlaPercentage,
  }));

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-2 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-semibold text-gray-900 text-xs">{label}</p>
          <p className="text-green-600 text-xs">Within SLA: {data.within}</p>
          <p className="text-red-600 text-xs">Breached SLA: {data.breached}</p>
          <p className="text-blue-600 font-semibold text-xs">
            Rate: {data.rate}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      <div className="h-1 " />
      <div className="p-2">
        <div className="mb-2 flex justify-between items-start">
          <div>
            <h2 className="card-heading-text">SLA Performance</h2>
            <p className="card-subheading-text pb-4">
              Monitor service level agreement compliance
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-1.5 mb-3">
          <div className="bg-green-50 border border-green-200 rounded-lg p-2 text-center">
            <div className="card-value-text font-bold text-green-600">
              {slaData?.result?.summary?.withinSla?.count}
            </div>
            <div className="text-xs text-gray-500 mb-0.5">Within SLA</div>
            <div className="card-value-text text-green-600">
              {slaData?.result?.summary?.withinSla?.percentage}%
            </div>
          </div>
          <div className="bg-red-50 border border-red-200 rounded-lg p-2 text-center">
            <div className="card-value-text text-red-600">
              {slaData?.result?.summary?.breachedSla?.count}
            </div>
            <div className="text-xs text-gray-500 mb-0.5">Breached SLA</div>
            <div className="card-value-text text-red-600">
              {slaData?.result?.summary?.breachedSla?.percentage}%
            </div>
          </div>
        </div>

        <div className="h-40">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={monthlyData}
              margin={{ top: 5, right: 15, left: 5, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis
                dataKey="month"
                axisLine={true}
                tickLine={true}
                tick={{ fontSize: 10, fill: "#6b7280" }}
                stroke="#e5e7eb"
              />
              <YAxis
                axisLine={true}
                tickLine={true}
                tick={{ fontSize: 10, fill: "#6b7280" }}
                stroke="#e5e7eb"
                label={{
                  value: "Orders",
                  angle: -90,
                  position: "insideLeft",
                  style: { fontSize: "10px" },
                }}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar
                dataKey="within"
                stackId="a"
                fill="#10b981"
                radius={[0, 0, 0, 0]}
              />
              <Bar
                dataKey="breached"
                stackId="a"
                fill="#ef4444"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
